import React from 'react';
import { Link } from 'react-router-dom';
import './PumpHome.css';

const PumpHome = () => {
  const pumpCategories = [
    { name: 'Submersible Pumps', icon: '🌊', description: 'For boreholes and deep wells', link: '/pump-products#submersible' },
    { name: 'Mono Block Pumps', icon: '⚙️', description: 'Self-priming surface pumps', link: '/pump-products#monoblock' },
    { name: 'Centrifugal Pumps', icon: '🔄', description: 'High flow for irrigation', link: '/pump-products#centrifugal' },
    { name: 'Solar Pumps', icon: '☀️', description: 'DC solar-powered systems', link: '/pump-products#solar' }
  ];

  return (
    <div className="pump-home">
      {/* Hero Section */}
      <section className="pump-hero">
        <div className="container">
          <h1>Versil Pumps & Motors</h1>
          <p className="hero-tagline">Connecting Water With You</p>
          <p className="hero-description">Sole importers and distributors of Versil brand submersible and mono block pumps in Kenya</p>
          <div className="hero-buttons">
            <Link to="/pump-catalogue" className="btn btn-primary">View Catalogue</Link>
            <Link to="/contact" className="btn btn-outline">Get Quote</Link>
          </div>
        </div>
      </section>

      {/* Quick Categories */}
      <section className="pump-categories">
        <div className="container">
          <h2>Our Pump Range</h2>
          <div className="categories-grid">
            {pumpCategories.map((cat, index) => (
              <Link to={cat.link} key={index} className="category-card">
                <div className="category-icon">{cat.icon}</div>
                <h3>{cat.name}</h3>
                <p>{cat.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="pump-features">
        <div className="container">
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">🇮🇹</div>
              <h3>Italian Technology</h3>
              <p>Versil pumps combine Italian design with robust construction</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🔧</div>
              <h3>Easy Maintenance</h3>
              <p>Service-friendly design with readily available spare parts</p>
            </div>
            <div className="feature">
              <div className="feature-icon">⚡</div>
              <h3>Energy Efficient</h3>
              <p>High efficiency motors reduce operating costs</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🛡️</div>
              <h3>1 Year Warranty</h3>
              <p>Comprehensive warranty on all pumps</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="pump-cta">
        <div className="container">
          <h2>Need a pump for your borehole or farm?</h2>
          <p>Contact us for expert advice and competitive pricing</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-light">Request Quote</Link>
            <a href="tel:0700241467" className="btn btn-outline-light">Call 0700 241467</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PumpHome;